// |-- Built-in Dependencies --|
import React from "react";

// |-- External Dependencies --|
import { BiSearchAlt2 } from "react-icons/bi";
import { IconType } from "react-icons";

// |-- Internal Dependencies --|
import ATMInputAdormant from "src/components/UI/atoms/formFields/ATMInputAdormant/ATMInputAdormant";
import { useParams } from "react-router-dom";
// import { IoFilter } from "react-icons/io5";
import { CircularProgress, Tooltip } from "@mui/material";

// |-- Types --|
type ViewLayoutPropTypes = {
  leftbar?: boolean;
  infoCard?: React.ReactNode;
  loader?: boolean
  actionIcons?: {
    icon: IconType;
    onClick: () => void;
  }[];
  listData?: any[];
  tabs?: {
    label: string;
    icon: IconType;
    path: string;
  }[];
  searchValue?: string;
  onSearch?: (value: string) => void;
  onClickViewMore?: () => void;
  onClickChangeRequestView?: (futurePurchaseId: string) => void;
  hideViewMore?: boolean;
  children?: any;
};

const FuturePurchaseSideBarLayout = ({
  leftbar = true,
  infoCard,
  listData,
  loader,
  tabs,
  searchValue = "",
  onSearch = () => { },
  onClickChangeRequestView = () => { },
  onClickViewMore,
  hideViewMore = false,
  children,
}: ViewLayoutPropTypes) => {
  // const navigate = useNavigate()
  const { futurePurchaseId } = useParams();
  // const [isOpenTicketFilterDialog, setIsOpenTicketFilterDialog] =
  //   useState<boolean>(false);
  return (
    <>
      <div className="h-[calc(100vh-50px)] border-r">
        <div className=" flex  h-[calc(100%)] bg-white">
          {/* Left Section Side Bar */}
          <div className="md:block hidden">
            {leftbar === true && (
              <div className="w-[250px]  h-full flex flex-col">
                {/* Info Card */}
                <div className=" w-full">{infoCard}</div>

                {/* Search Bar */}
                <div className="px-2 py-2 flex items-center justify-center ">
                  <ATMInputAdormant
                    name=""
                    value={searchValue}
                    placeholder="Search here..."
                    className="h-[40px] shadow-sm border-[1px] focus:border-black"
                    adormant={
                      <BiSearchAlt2 className="text-slate-400 text-xl " />
                    }
                    adormantProps={{
                      position: "start",
                      extraClasses: "bg-white border-0 ",
                    }}
                    onChange={(e) => {
                      onSearch(e.target.value);
                    }}
                  />
                  {/* Filter Button */}
                  {/* <button
                    type="button"
                    onClick={() => setIsOpenTicketFilterDialog(true)}
                    className={`ml-2 rounded-lg h-[40px] w-[40px] flex justify-center items-center border border-gray-200 text-gray-600 shadow bg-gray-200 aspect-square`}
                  >
                    <IoFilter />
                  </button> */}
                </div>

                {/* List */}
                <div className="grow overflow-auto">
                  {loader && (
                    <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                      <CircularProgress />
                    </div>
                  )}
                  <div className="px-[8px] flex flex-col min-w-[100%] overflow-y-auto">
                    {listData?.map((ele: any) => {
                      return (
                        <div
                          key={ele?._id}
                          className={`shadow-sm mb-2 border-[1px] rounded cursor-pointer relative ${ele?._id === futurePurchaseId ? "bg-[#f8edd0] border-accent" : "bg-white border-slate-100"
                            }`}
                          onClick={() => onClickChangeRequestView(ele?._id)}
                        >
                          <div className="flex gap-x-2 py-2 px-2">
                            <div className="bg-[#ebebeb] text-md rounded-md px-1 py-[1px]">
                              <div className="text-xs text-black font-bold">
                                Phone number :  <span >{ele?.mobile}</span>
                              </div>
                            </div>
                          </div>

                          <div className="p-4" style={{ userSelect: "text" }}>
                            <Tooltip title={ele?.name}>
                              <h3 className="w-full overflow-hidden truncate text-md min-w-[100%] hover:underline font-medium">
                                {ele?.name}
                              </h3>
                            </Tooltip>

                            <div className="flex text-sm  justify-between mt-1 font-semibold text-red-500 ">
                              <span className="task-id mt-1">
                                {/* #{ele?.location} */}
                              </span>
                              <span>
                                {ele?.status}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {/* View more button */}
                    {hideViewMore && (
                      <span
                        onClick={onClickViewMore}
                        className="text-black text-center text-sm cursor-pointer hover:underline select-none"
                      >
                        View More
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FuturePurchaseSideBarLayout;
